import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { LoadingService } from '@shared-services/loading.service';
import { SharedUserProvider } from '@shared-providers/api/user.provider';
import { IUser } from '@shared-models/user.model';
import { IEmployee } from '@internal-models/employee.model';

@Injectable({
	providedIn: 'root',
})
export class PublicUserProvider extends SharedUserProvider {
	protected readonly url: string = '/users';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(api, loadingService);
	}

	public requestReset(credentials: { username: string }): Promise<IUser> {
		return this.process(this.api.post<any>(`${this.url}/reset`, credentials)) as Promise<IUser>;
	}

	public reset(credentials: { code: string; password: string }): Promise<IUser> {
		return this.process(this.api.post<any>(`${this.url}/reset/confirm`, credentials)) as Promise<IUser>;
	}

	public register(employee: IEmployee & { TenantId: string }): Promise<void> {
		return this.process(this.api.post<any>(`/employees/register`, employee)) as Promise<void>;
	}
}
